import AdminConfig from './admin.vue'
import ClientView from './client.vue'

export default {
  name: 'repartition',
  type: 'module',
  label: 'Répartition',
  components: { admin: AdminConfig, client: ClientView },
  settings: { icon: 'mdi-view-grid-plus-outline' }
}
